export const fuelType: { [key: number]: string } = {
  1: 'petrol',
  3: 'diesel',
  6: 'electric',
  5: 'hybrid',
};

export enum FuelTypeEnum {
  Petrol = 1,
  Diesel = 3,
  Electric = 6,
  Hybrid = 5,
}
